export enum PromoCodeButtonTypeEnum {
  ARCHIVE = 'archive',
  CREATE = 'create',
}
